var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddcolIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.81543,
    y: 0.828125,
    width: 10.1846,
    height: 10.3438,
    rx: 5.09231,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.13537 5.67676H6.22575V3.7373C6.22575 3.65158 6.19222 3.56936 6.13253 3.50874C6.07285 3.44812 5.99189 3.41406 5.90748 3.41406C5.82307 3.41406 5.74212 3.44812 5.68243 3.50874C5.62274 3.56936 5.58921 3.65158 5.58921 3.7373V5.67676H3.6796C3.59519 5.67676 3.51423 5.71081 3.45455 5.77143C3.39486 5.83205 3.36133 5.91427 3.36133 6C3.36133 6.08573 3.39486 6.16795 3.45455 6.22857C3.51423 6.28919 3.59519 6.32324 3.6796 6.32324H5.58921V8.2627C5.58921 8.34842 5.62274 8.43064 5.68243 8.49126C5.74212 8.55188 5.82307 8.58594 5.90748 8.58594C5.99189 8.58594 6.07285 8.55188 6.13253 8.49126C6.19222 8.43064 6.22575 8.34842 6.22575 8.2627V6.32324H8.13537C8.21978 6.32324 8.30073 6.28919 8.36042 6.22857C8.4201 6.16795 8.45364 6.08573 8.45364 6C8.45364 5.91427 8.4201 5.83205 8.36042 5.77143C8.30073 5.71081 8.21978 5.67676 8.13537 5.67676Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddcolIcon);
export default __webpack_public_path__ + "static/media/addcol-icon.02c8126b11d8bfd745d82e572e1b44c1.svg";
export { ForwardRef as ReactComponent };